module.exports = __webpack_public_path__ + "assets/img/tab3_04.e448995f.jpg";